module.exports = __webpack_public_path__ + "img/specialty3.2254555.png";